import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Graph from './components/Graph';
import API from '../../services/API';


class BidderSourcesGraph extends Component {
    constructor() {
        super();

        this.state = {
            graph: {},
            total: [],
            sources: [],
            isLoading: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.setState({ isLoading: true });
        this.loadSources();

        const date = new Date().toISOString().split('T')[0];

        this.loadGraph({ day: date })
    }

    handleSubmit(filters) {
        this.setState({ isLoading: true });

        this.loadGraph(filters);
    }

    loadSources() {
        this.setState({ isLoading: true });

        API.BidderSources.get().then(sources => {
            sources = sources.map(row => row.name);

            this.setState({ sources, isLoading: false })
        });
    }

    loadGraph(filters) {
        API.BidderSourcesGraph.get(filters)
            .then(({ graphs, total }) => this.setState({ isLoading: false, graph: graphs, total }));
    }

    getGraphs() {
        const { graph, total, } = this.state;
        const graphs = [];


        if(total.length) {
            graphs.push(<Col key={'total'}>
                <h4 style={{ textAlign: 'center' }}>Total</h4>
                <Col lg={12}>
                    <Graph data={total} />
                </Col>
            </Col>)
        }

        Object.keys(graph).map(source => {
            graphs.push(
                <Col key={source}>
                    <h4 style={{ textAlign: 'center' }}>{source}</h4>
                    <Col lg={12}>
                        <Graph
                            data={graph[source]}
                        />
                    </Col>
                </Col>
            );
        });


        return graphs;
    }

    render() {
        const { isLoading, sources } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="Bidder Sources Graph"/>
                <Form onSubmit={this.handleSubmit} sources={sources}/>

                {this.getGraphs()}
            </Container>
        );
    }
}

export default BidderSourcesGraph;



// WEBPACK FOOTER //
// ./src/scenes/BidderSourcesGraph/index.js